module.exports = __webpack_public_path__ + "img/auth-bg1-large.b2d12a82.png";